export const APP_VERSION = "3.8";

export const CHANGELOG = [
  {
    version: "3.8", date: "Jun 2026", title: "Always up to date on iPhone & Android",
    items: [
      ["new", "The news feed shows your device's version: an Update button in the Android app, and a Reload button when the iPhone or web app has a newer version."],
      ["change", "Aphelion checks for new versions whenever you come back to it."],
    ],
  },
  {
    version: "3.7", date: "Jun 2026", title: "New version ready to download",
    items: [
      ["new", "Aphelion 3.7 for Android is out. Get it from the download link above. It installs over your current app and keeps your vault."],
      ["change", "The news feed now always shows where to download the latest version."],
    ],
  },
  {
    version: "3.6", date: "Jun 2026", title: "News feed & update alerts",
    items: [
      ["new", "This What's New feed appears after an update so you always know what changed."],
      ["new", "The Android app tells you when a newer version is ready to download."],
      ["new", "A one-tap card in your chat list turns on lock-screen alerts in the browser and Home Screen app."],
    ],
  },
  {
    version: "3.5", date: "Jun 2026", title: "Stability",
    items: [
      ["fix", "Fixed the \"Orbit disrupted\" crash when sending a message or tapping back on some Android phones."],
      ["fix", "Automatic page translation no longer breaks the app."],
      ["change", "If a screen ever fails, Aphelion now recovers on its own."],
    ],
  },
  {
    version: "3.4", date: "Jun 2026", title: "Tappable links",
    items: [
      ["new", "Links in messages are now tappable, and open in your phone's browser from the Android app."],
    ],
  },
  {
    version: "3.3", date: "Jun 2026", title: "Log in anywhere",
    items: [
      ["new", "Log in on another device with a passphrase-locked login key (QR, text or file)."],
      ["fix", "The phone's back gesture now returns to your chats instead of leaving the app or showing a blank page."],
      ["change", "Brand-new lock-and-orbit app icon."],
    ],
  },
  {
    version: "3.2", date: "Jun 2026", title: "New home",
    items: [
      ["change", "Aphelion now lives at aphelionchat.app."],
      ["new", "A one-tap banner to install Aphelion on Android or iPhone."],
    ],
  },
  {
    version: "2.2", date: "Jun 2026", title: "Snaps & Stories, upgraded",
    items: [
      ["new", "Contact requests: approve or block new people before a chat appears."],
      ["new", "Blocked IDs list, Snap replies, story replies and private emoji reactions."],
      ["new", "Screenshot alerts on Android and lock-screen alerts in the browser."],
    ],
  },
];

const parts = (v) => String(v).split(".").map((n) => parseInt(n, 10) || 0);
export const isNewer = (a, b) => {
  const [x, y] = [parts(a), parts(b)];
  for (let i = 0; i < Math.max(x.length, y.length); i++) {
    if ((x[i] || 0) !== (y[i] || 0)) return (x[i] || 0) > (y[i] || 0);
  }
  return false;
};
